import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2kggure7n: FaireProductEntity = {
  token: "p_z2kggure7n",
  type: "product",
  name: "BASEBALL MOM - 1/4 Zip Sweatshirt w/front pouch pocket",
  brandToken: "b_spmjnz3e",
  brandName: "Lemon Lorraine's LLC",
  imageUrl: "https://cdn.faire.com/fastly/ca48ce18d45d1683fcb1b87a86904fa7e73c3af590c745057c8847a4785811a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/543adfb0c5b3b74db78bcac13a7dbdf967b0a3194fdc987a0609cba8a5b8ef41.jpeg",
    "https://cdn.faire.com/fastly/9fbca04933d015ce3ad70c5711bcbb119e3069555f1bbba342e4805c44afe7b7.jpeg",
    "https://cdn.faire.com/fastly/796f4e7abc90ca289477e65b5abe039a1289d5508fa2f978ed95507d51ed7f51.jpeg",
    "https://cdn.faire.com/fastly/faf5756d6e40710dc958f986f4a4c0695f0f2b305d52e825eacb4ee112e8430d.jpeg",
    "https://cdn.faire.com/fastly/8c421ad326d690e30473ffe8044009cc26de4d0b5a07321822d641a36d68cb59.jpeg"
  ],
  priceDollars: 24.5,
  description: "COLOR: Light Heather Grey\nFIT: Soft Unisex, true to size \nEXTRAS: DT6106 - Quarter Zip with front pouch pocket \nMATERIAL: 60/40 ringspun cotton/polyester\nPRINT: Professionally screen printed (Black & Red ink) \n\nGraphic tees that are stylish, durable and BRING YOUR STORY TO LIFE!",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:31.579Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
